<div class="{{localService.selectedLanguageCode}}">
    <div class="tab-outer" *ngIf="tabs" [id]="elementIds.tab_container" (window:resize)="onResize($event)">
        <div class="tab-outer-item" [id]="elementIds.tab_container_action_1">
            <button *ngIf="isShowRefresh" class="button_icon button_icon_color icon_adjust" style="border: none;"
                (click)="onAction(4)">refresh</button>
        </div>
        <div class="tab-outer-item tab-outer-item-1" [id]="elementIds.tab_container_action_2">
            <button class="button_icon button_icon_color icon_adjust navigation" (click)="onAction(3,'-1')"
                [disabled]="selectedIndex == 0">keyboard_arrow_left</button>
            <button class="button_icon button_icon_color icon_adjust navigation" (click)="onAction(3,'1')"
                [disabled]="selectedIndex == tabs.length - 1">keyboard_arrow_right</button>
        </div>
        <div class="tab-outer-item tab-outer-item-2" [id]="elementIds.tab_container_items"
            [ngStyle]="{'width' : tabWidth + 'px'}">
            <button class="btn btn-primary" *ngFor="let item of tabs;index as i"
                id="{{elementIds.tab_container_items + '-' + i}}"
                [ngClass]="item.isSelected ? (selectedKey == item.key ? 'selected-tab-danger' : 'not-selected-tab-danger') :  (selectedKey == item.key ? 'selected-tab' : 'not-selected-tab')"
                (click)="onAction(2,item.key)">
                {{item.value}}
            </button>
        </div>
    </div>
</div>